import React from "react";
import cn from "classnames";
import { Link } from "gatsby";
import { useRecoilState } from "recoil";
import { collapsedState } from "../../utils/recoil-atoms";
import logo from "../../assets/images/logo-dark.png";

/**
 *
 * @param {object} props
 * @param {boolean} props.sticky
 * @returns
 */
const Navbar = props => {
  const { sticky } = props;
  const [collapsed, setCollapsed] = useRecoilState(collapsedState);
  const menus = [
    { title: "首页", to: "/" },
    {
      title: "产品",
      children: [
        { title: "人才招聘", to: "/recruitment" },
        { title: "组织发展", to: "/organization" },
        { title: "员工发展", to: "/develop" },
        { title: "培训管理", to: "/training" },
        { title: "薪酬福利", to: "/salary" },
        { title: "绩效考评", to: "/performance" },
        { title: "时间管理", to: "/attendance" },
        { title: "核心人事", to: "/employee" },
        { title: "个人中心", to: "/selfcenter" },
        { title: "人力外包", to: "/hro" },
      ],
    },
    { title: "产品优势", to: "/superiority" },
    { title: "客户案例", to: "/trends/page_1" },
    { title: "行业资讯", to: "/industryInfo/all/page_1" },
    { title: "关于我们", to: "/about", rel: "nofollow" },
  ];

  const toggleNavbar = () => {
    setCollapsed(!collapsed);
  };

  const setSticky = element => () => {
    if (sticky) return;
    if (window.scrollY > 170) {
      element.classList.add("is-sticky");
    } else {
      element.classList.remove("is-sticky");
    }
  };

  React.useEffect(() => {
    const elementId = document.getElementById("navbar");
    const setNavbarSticky = setSticky(elementId);
    document.addEventListener("scroll", setNavbarSticky);
    window.scrollTo(0, 0);
    return () => {
      document.removeEventListener("scroll", setNavbarSticky);
    };
  });

  const renderMenu = () => {
    return (
      <ul className="navbar-nav">
        {menus.map(({ title, to, children, ...rest }) => (
          <li className="nav-item" key={title}>
            <Link to={to} activeClassName="active" onClick={() => setCollapsed(true)} className="nav-link" {...rest}>
              {title}
              {children && <i className="bx bx-chevron-down ml-1"></i>}
            </Link>
            {children && (
              <ul className="dropdown-menu">
                {children.map(({ title: childTitle, to: childTo }) => (
                  <li className="nav-item">
                    <Link to={childTo} activeClassName="active" onClick={() => setCollapsed(true)} className="nav-link">
                      {childTitle}
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    );
  };

  return (
    <div
      id="navbar"
      className={cn("navbar-area", {
        "is-sticky": sticky,
      })}
    >
      <div className="tarn-nav">
        <div className="container-fluid">
          <nav className="navbar navbar-expand-lg navbar-light">
            <Link to="/" onClick={() => setCollapsed(true)} className="navbar-brand">
              <img src={logo} alt="大任人力资源管理系统" className="navbar-brand-img" />
            </Link>
            <div className="option-item">
              <i className="bx bx-phone-call"></i>
              <a className="main-link" href="tel:400-028-5267">
                400-028-5267
              </a>
            </div>

            <button
              onClick={toggleNavbar}
              className={cn("navbar-toggler", "navbar-toggler-right", {
                collapsed,
              })}
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="icon-bar top-bar"></span>
              <span className="icon-bar middle-bar"></span>
              <span className="icon-bar bottom-bar"></span>
            </button>

            <div
              className={cn("collapse", "navbar-collapse", {
                show: !collapsed,
              })}
              id="navbarSupportedContent"
            >
              {renderMenu()}

              <div className="others-option d-flex align-items-center">
                <div className="option-item">
                  <a id="loginButton" target="_blank" rel="noreferrer" href="https://hr.darensoft.com" className="btn btn-outline-main">
                    登录
                  </a>
                </div>
                <div className="option-item">
                  <Link to="/reservation" rel="nofollow" activeClassName="active" onClick={() => setCollapsed(true)} className="btn btn-primary">
                    预约演示
                  </Link>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
